import React from 'react';
import QuestionCard from '../forms/QuestionCard';
import { useFormContext } from '../../context/FormContext';

const LearningEnvironmentQuestions = ({
  questionNumber,
  categories,
  totalQuestions
}) => {
  const { formData, handleInputChange } = useFormContext();
  
  switch(questionNumber) {
    case 1:
      return (
        <QuestionCard 
          categoryIcon={categories[4].icon}
          categoryName={categories[4].name}
          questionNumber={1}
          totalQuestions={totalQuestions}
          title="当你刚接到一个复杂项目或任务时，你更自然的反应是？" 
          subtitle="(可以回忆一次课程小组作业/group presentation/final project、竞赛、或社团活动准备）"
          inputType="radio"
          options={[
            "A. 想先自己把整体思路理清楚，再决定怎么和别人沟通",
            "B. 会第一时间找人一起开会、讨论思路、一起分工启动",
            "C. 我暂时说不太上来自己更偏哪种",
          ]}
          value={formData.collaborationStyle}
          onChange={(value) => handleInputChange('collaborationStyle', value)}
        />
      );
    case 2:
      return (
        <QuestionCard 
          categoryIcon={categories[4].icon}
          categoryName={categories[4].name}
          questionNumber={2}
          totalQuestions={totalQuestions}
          title="哪种工作方式更能让你产生动力、投入感？" 
          subtitle="（可以回忆你完成某个group project时，哪个环节让你特别&quot;想动起来&quot;）"
          inputType="radio"
          options={[
            "A. 自己先想清楚核心逻辑、设计方案后，再推进执行或交流",
            "B. 跟大家一起不断沟通、出主意、推动项目向前，让我最有感觉",
            "C. 我暂时说不太上来自己更偏哪种",
          ]}
          value={formData.motivation}
          onChange={(value) => handleInputChange('motivation', value)}
        />
      );
    case 3:
      return (
        <QuestionCard 
          categoryIcon={categories[4].icon}
          categoryName={categories[4].name}
          questionNumber={3}
          totalQuestions={totalQuestions}
          title="你提交了一份报告初稿，教授提供了两种不同类型的反馈：一位教授详细标出了需要修改的具体段落和建议的修改方向（如&quot;这里需要使用这个公式&quot;），另一位只提供了一些大方向的思考问题（如&quot;考虑其他可能的竞对分析方法&quot;）让你自己探索改进。哪种反馈方式你更喜欢？为什么?" 
          value={formData.feedbackPreference}
          onChange={(value) => handleInputChange('feedbackPreference', value)}
          inputType="textarea"
        />
      );
    case 4:
      return (
        <QuestionCard 
          categoryIcon={categories[4].icon}
          categoryName={categories[4].name}
          questionNumber={4}
          totalQuestions={totalQuestions}
          title="回想过去的小组工作经历（如有）。在没有明确分工的小组项目中，你通常会自然而然地承担什么角色？" 
          subtitle="（提示：组织领导者、创意提供者、协调者/调解意见者、细节检查者、时间线把握者、分析利弊者等）"
          value={formData.groupRole}
          onChange={(value) => handleInputChange('groupRole', value)}
          inputType="textarea"
        />
      );
    default:
      return null;
  }
};

export default LearningEnvironmentQuestions;